import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoGez: CultureInfo = {
  name: 'gez',
  displayName: 'ግዕዝኛ',
  iso3LanguageCode: 'gez',
  iso2LanguageCode: 'gez',
  ietfLanguageTag: 'gez',
  parent: null
};
